import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventSubscriptionEditComponent } from '../event-subscription-edit/event-subscription-edit.component';

@Component({
    selector: 'event-subscription-modal',
    template: require('./event-subscription-modal.component.html'),
})
export class EventSubscriptionModalComponent {
    @Input() subscriptionId: number = 0;
    @Input() projectId: number | null = null;

    @ViewChild(EventSubscriptionEditComponent) editComp: EventSubscriptionEditComponent;

    constructor(public activeModal: NgbActiveModal) {}

    get savedSecret(): string | null { return this.editComp ? this.editComp.savedSecret : null; }
    get secretCopied(): boolean { return this.editComp ? this.editComp.secretCopied : false; }
    copySecret() { if (this.editComp) { this.editComp.copySecret(); } }

    onSaved() { this.activeModal.close(); }
    onCancelled() { this.activeModal.dismiss(); }
}
